import { type QueryClient, queryOptions } from '@tanstack/react-query';

import { inviteListInvitesQueryKey } from '@column/api';

import { UserRepository } from '~/repositories';
import { RoleRepository } from '~/repositories/RoleRepository';

export const teamQueryKeys = {
  users: (platformId?: string) => ['users', 'platform', platformId],
  roles: () => ['roles'],
};

export const usersQueryOptions = (platformId?: string) =>
  queryOptions({
    queryKey: teamQueryKeys.users(platformId),
    queryFn: async () => {
      if (!platformId) throw new Error('No platform selected');
      return UserRepository.getAll({ platformId });
    },
    enabled: !!platformId,
  });

export const rolesQueryOptions = () =>
  queryOptions({
    queryKey: teamQueryKeys.roles(),
    queryFn: async () => RoleRepository.list(),
  });

export const invalidateAdminApprovals = (queryClient: QueryClient) =>
  queryClient.invalidateQueries({ queryKey: [{ _id: 'adminapprovalListAdminApprovals' }] });

export const invalidateApprovalSubjects = (queryClient: QueryClient) => {
  invalidateAdminApprovals(queryClient);
  queryClient.invalidateQueries({ queryKey: ['users'] });
  queryClient.invalidateQueries({ queryKey: inviteListInvitesQueryKey() });
  queryClient.invalidateQueries({ queryKey: teamQueryKeys.roles() });
};
